<template>
    <div><!-- 帳款查詢 -->
        <CCard class="w-100">
            <CCardHeader>
                <strong>{{$t('AccountQuery.AccountQuery')}}</strong>
            </CCardHeader>
            <CCardBody>
                    <CForm>
                        <div class="CForminline">
                            <div class="supplier">
                                <p>{{$t('OrderInfo_Vue.VendorId')}}：</p>
                                <input type="text" v-if="isDisableVendorId" :disabled="isDisableVendorId" v-model="accountQueryParam.vendorId">                                                        
                                <Select2 style="width: 500px;" v-if="!isDisableVendorId" v-model="accountQueryParam.vendorIdList" :options="memberListFilter()" :settings="{ 'multiple': 'true' }" />
                            </div>
                            <div class="number_range">
                                <p>{{$t('AccountQuery.InvoiceDate')}}：</p>
                                <date-picker :lang="lang" format="YYYY-MM-DD" valueType="format" v-model="accountQueryParam.invoiceDateBegin"></date-picker>
                                <span>~</span>
                                <date-picker :lang="lang" format="YYYY-MM-DD" valueType="format" v-model="accountQueryParam.invoiceDateEnd"></date-picker>
                            </div>
                            <div class="btn_group">                               
                                <button type="button" class="btn btn-edit mr-2" @click="accountSearchEvent">{{$t('Buttons.Query')}}</button>
                                <button type="button" class="btn btn-blue mr-2" @click="accountExportEvent">{{$t('Buttons.ExportOrder')}}</button>
                            </div>                            
                        </div>
                    </CForm>
            </CCardBody>
        </CCard>
    </div>
</template>

<script>
import { orderMixin } from '@/mixin/order'
import { mapGetters } from 'vuex'
export default {
    mixins: [orderMixin],
    data() {
        return {
            accountQueryParam :{
                vendorId: '', 
                vendorIdList:[],
                invoiceDateBegin: null,               
                invoiceDateEnd: null
            },
            accountRow : {}
        }
    },
    props : {
    },
    methods: {
        checkSearchParam(){ //檢核條件
           const {invoiceDateBegin,invoiceDateEnd} =this.accountQueryParam;
           let errMsg = '';
           if(invoiceDateBegin && invoiceDateEnd){
               if(invoiceDateBegin>invoiceDateEnd){
                 errMsg='發票日期區間錯誤，起始日不得大於終止日!';
               }
           }         
           if(errMsg){
                this.$alert(errMsg , '警告',{type: 'warning'});
                return false;
           }
           return true;
        },
        accountSearchEvent (){ //搜尋
            if(!this.checkSearchParam()){
                return;
            }
            this.$emit('accountSearch', this.accountQueryParam);
        },
        accountExportEvent (){ //匯出
            const url = `${this.$apiUrl_Order}/PrepareSearchAccounExport`;
            this.axios.post(url, this.accountQueryParam).then((response) => {                        
                const respObj = response.data;                 
                const exportExcelToken = respObj.token;
                let urlExcel = `${this.$apiUrl_Order}/SearchAccounExportExcel/${exportExcelToken}`;
                this.openNewTabByALink('accounExportExcel',urlExcel);
            })
        }
    },
    computed: {
        ...mapGetters(["lang"]),
        isDisableVendorId (){
            if(this.isMember){
                return true;
            }
            return false;
        }
    },
	mounted() {
        let userInfo = this.$userInfo ;
        if(this.isMember){            
            this.accountQueryParam.vendorId = userInfo.vendorId;            
        }else{
            this.initMemberList();
        }

	},
    created() {        
    }
}
</script>

<style lang="scss" scoped>
.CForminline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > .form-group {
        margin-bottom: 0;
    }

    > .supplier, .date_range, .number_range, .watch, .check {
        display: flex;
        align-items: center;
        margin: .5rem 0;
        > p {
            margin-right: 1rem;
            margin-bottom: 0;
        }
        > .purchase_input {
            margin-bottom: 0;
        }
        > input {
            margin: 0 .5rem;
        }
    }
}

.purchase {
    width: 100%;
}

.btn-edit {
    background-color: #343b55;
    color: white;
}

.btn-blue {
    background-color: #1045e6;
    color: white;
}
</style>
